import React from 'react'
import { useAtSize } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import CountUp from 'react-countup'
import { number, string } from 'prop-types'
import animation from '../../../../../shared/services/cssAnimations'

export default function CountryPercentage({ percent, alpha2, color }) {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const progressBarStyle = css`
    width: 100%;
    height: 12px;
    border-radius: 10px;
    background-color: #ccc;
    overflow: hidden;
  `
  const percentStyle = css`
    font-size: 28px;
    color: ${color};
    margin-top: 4px;
  `
  const countryLabelStyle = css`
    font-size: 14px;
    font-family: museo;
  `
  const countryElemementStyle = css`
    margin: ${atSize({ default: '12px', xl: '20px' })};
  `
  const Range = ({ percentRange, fillColor }) => {
    const rangeStyle = css`
      height: 100%;
      width: ${percentRange}%;
      background-color: ${fillColor};
      animation: ${animation('grow-from-left')} 1800ms;
    `
    return <div css={rangeStyle} />
  }

  const ProgressBar = ({ percentRange, fillColor }) => {
    return (
      <div css={progressBarStyle}>
        <Range percentRange={percentRange} fillColor={fillColor} />
      </div>
    )
  }

  return (
    <div css={countryElemementStyle}>
      <ProgressBar percentRange={percent} fillColor={color} />
      <div>
        <div css={percentStyle}>
          <CountUp end={percent} duration={2} />%
        </div>
        <div css={countryLabelStyle}>{t(`global.countries.country${alpha2}`, alpha2)}</div>
      </div>
    </div>
  )
}

CountryPercentage.propTypes = {
  percent: number.isRequired,
  alpha2: string.isRequired,
  color: string,
}
